export default {
  mediumText: "安全 快捷 巨省",
  bigText: "包网服务 行业首选",
  squareText1: "专业团队",
  squareText2: "优质服务",
  squareText3: "技术突破",
  squareText4: "安全高效",
};
